module.exports = __webpack_public_path__ + "img/icon-btc-white.9fb32c79.svg";